import { FormArray, FormControl, FormGroup } from '@angular/forms';

export class FormUtils {
  static getFormControl<EntityType>(form: FormGroup, controlName: keyof EntityType): FormControl {
    return form.get(controlName as string) as FormControl;
  }

  static getFormArray<EntityType>(form: FormGroup, controlName: keyof EntityType): FormArray {
    return form.get(controlName as string) as FormArray;
  }

  static getFormControlValue<EntityType>(form: FormGroup, controlName: keyof EntityType) {
    return FormUtils.getFormControl<EntityType>(form, controlName).value;
  }

  static formValidityCheck(form: FormGroup): boolean {
    if (!form.valid) {
      form.markAllAsTouched();
      return false;
    }
    return true;
  }
}
